import gsap, { Power4 } from 'gsap/all';
import $ from 'jquery';

const template = `
    <div class="imageWrapper">
      <div class="image-loader">
      </div>
    </div>
`;

const textWrap = `<div class="percent-text"></div>`


class Preloader {


  counter = 0;

  constructor() {
    const wrapper = $('.preloader');//$('<div class="preloader">');
    this.wrapper = wrapper;
    const image = new Image();
    image.src = '/textures/logo.png';
    image.className += 'main';
    const image2 = new Image();
    image2.src = '/textures/logo.png';
    image2.className += 'cover';
    wrapper.append($(template))
    wrapper.find('.image-loader').append($(image));
    wrapper.find('.image-loader').append($(image2));
    const $textWrap = $(textWrap);
    wrapper.find('.image-loader').append($textWrap);

    this.setProgress = (value) => {
      const style = `rect(0px, 100px, 100px, ${value}px)`;
      const style2 = `rect(0px,  ${value}px, 100px, 0px)`;
      $textWrap.html(`${Math.round(value * 10) / 10}%`)
      $(image2).css('clip', style2);
      if (value >= 100) {
        value = 100;
      }
    }
    window.setProgress = this.setProgress;
    this.image = image;
    this.image2 = image2;
  }

  startHide = () => {
    gsap.to('.image-loader', {
      duration: .25,
      opacity: 0,
      onComplete: () => {
        this.wrapper.addClass('inactive');
      }
    });
    gsap.to(this.wrapper, {
      duration: .5,
      opacity: 0,
      onComplete: () => {
        this.hide();
      }
    });
  }

  hide = () => {
    this.wrapper.remove();
  }
  setSplashLogoSrc = (logo) => {
    this.image.src = logo;
    this.image2.src = logo;
  }



}

export { Preloader }
